import {useInfiniteQuery, InfiniteData} from '@tanstack/react-query';
import {fundraisersApi} from '../api';
import {FundraiserDocumentsResponse} from '../model';

export const useFundraiserDocuments = (appealId: string, pageSize: number = 25) => {
  const getInfiniteDocuments = useInfiniteQuery<
    FundraiserDocumentsResponse,
    Error,
    InfiniteData<FundraiserDocumentsResponse>,
    ['fundraiser-documents', 'infinite', typeof appealId, typeof pageSize],
    string | undefined
  >({
    queryKey: ['fundraiser-documents', 'infinite', appealId, pageSize],
    queryFn: ({pageParam}) => {
      return fundraisersApi.getFundraiserDocuments({
        appealId,
        pageSize,
        after: pageParam,
      });
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage, _allPages, _lastPageParam) => {
      return lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined;
    },
    staleTime: 60 * 1000,
    enabled: !!appealId,
  });

  return {
    getInfiniteDocuments,
  };
};
